var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"clickable",attrs:{"id":"googleBtn","src":_vm.buttonImage},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }